module.exports = __webpack_public_path__ + "static/media/logo.dfb9ba7d.png";